import { gql } from "@apollo/client"

export const SUBSCRIBE_EMAIL_TO_NEWSLETTER = gql`
  mutation SubscribeEmailToNewsletter(
    $email: String!
    $status: Int
    $wedding_role: String
    $event_date: String
  ) {
    subscribeEmailToNewsletter(
      email: $email
      status: $status
      wedding_role: $wedding_role
      event_date: $event_date
    ) {
      status
    }
  }
`
